<template>
  <div class="fzs" @click="clickTimes">
    <BlogHeader :index = "'1'"></BlogHeader>
    <div style="height: 60px;"></div>
    <my-blog></my-blog>
    <div style="margin: 40px 6% 0 6%;padding: 30px;">
      <el-row style="margin-bottom: 20px;">
        <el-col :span="17" class="three-pic" v-loading="threePicLoading">
          <el-card shadow="hover" class="threepic" >
            <el-carousel :interval="5000" arrow="always" height="360.2px">
              <el-carousel-item v-for="(item,key) in imgs" :key="item.img">
                <img v-lazy="item .img"/>
              </el-carousel-item>
            </el-carousel>
          </el-card>
        </el-col>

        <el-col :span="6" :offset="1" class="new">
          <el-card shadow="hover" v-loading="topLoading">
            <el-tag type="warning"><i class="el-icon-time"></i>&nbsp;{{$t('new')}}</el-tag>
            <el-slider v-model="clickNum" :show-tooltip="false"></el-slider>
            <el-collapse v-model="activeName1" accordion  v-for="(item,key) in top" :key="item.id">
              <el-collapse-item :title="item.title|handle_str(1)" :name="key">
                <div class="intro">{{item.intro}}</div>
                <div class="url-detail"><span><i class="el-icon-time"></i>&nbsp;{{$t('time')}}{{item.addtime|handle_str(time)}}</span><a :href="'/#/detail/'+item.id"><i class="el-icon-search"></i>&nbsp;{{$t('detail')}}</a></div>
              </el-collapse-item>
            </el-collapse>
          </el-card>
        </el-col>
      </el-row>

      <el-row style="margin-bottom: 20px">

        <el-col :span="17" style="background-color: white" class="article">
          <el-card shadow="hover">
            <el-button type="primary" icon="el-icon-search" @click="urlRedirect(0,1)" circle></el-button>&nbsp;<el-tag type="warning">{{$t('it')}}</el-tag>
          <el-slider v-model="clickNum" :show-tooltip="false"></el-slider>
            <el-row :gutter="5"  v-loading="listLoading">
              <el-col :span="8" v-for="(item,key) in list" :key="item.id">
                <el-card :body-style="{ padding: '0px' }"  shadow="hover" v-if="item.type>1">
                  <img v-lazy="'http://img.fang99.cc/'+item.pic"/>
                  <div style="padding: 10px;">
                  <span>
                    <h3>{{item.title|handle_str(1,17)}}</h3>
                    <h4>{{item.intro|handle_str(1,17)}}</h4>
                  </span>
                    <div>
                      <time class="time">{{item.addtime|handle_str(2)}}</time>
                      <el-button size="small" type="primary" @click="urlRedirect(item.id,0)" icon="el-icon-search" style="float: right;margin-bottom: 10px;" round>{{$t('watch')}}</el-button>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="6" :offset="1">
          <el-card shadow="hover" v-loading="topLoading">
            <el-tag type="warning"><i class="el-icon-view"></i>&nbsp;{{$t('hotlook')}}</el-tag>
            <el-slider v-model="clickNum" :show-tooltip="false"></el-slider>
            <el-collapse v-model="activeName2" accordion  v-for="(item,key) in look" :key="item.id">
              <el-collapse-item :title="item.title|handle_str(1,17)" :name="key+4">
                <div class="intro">{{item.intro}}</div>
                <div class="url-detail"><span><i class="el-icon-view"></i>&nbsp;{{$t('looknum')}}{{item.look}}</span><a :href="'/#/detail/'+item.id"><i class="el-icon-search"></i>&nbsp;{{$t('detail')}}</a></div>
              </el-collapse-item>
            </el-collapse>
          </el-card>
        </el-col>
      </el-row>

      <el-row>

        <el-col :span="17" style="background-color: white" class="article">
          <el-card shadow="hover">
            <el-button type="primary" icon="el-icon-search" @click="urlRedirect(0,2)" circle></el-button>&nbsp;<el-tag type="warning">{{$t('diary')}}</el-tag>
            <el-slider v-model="clickNum" :show-tooltip="false"></el-slider>
            <el-row :gutter="5"  v-loading="listLoading">
              <el-col :span="8" v-for="(item,key) in list" :key="item.id">
                <el-card :body-style="{ padding: '0px' }"  shadow="hover" v-if="item.type==1">
                  <img v-lazy="'http://img.fang99.cc/'+item.pic"/>
                  <div style="padding: 10px;">
                  <span>
                    <h3>{{item.title}}</h3>
                    <h4>{{item.intro|handle_str(1,25)}}</h4>
                  </span>
                    <div>
                      <time class="time">{{item.addtime|handle_str(2)}}</time>
                      <el-button size="small" type="primary" @click="urlRedirect(item.id,0)" icon="el-icon-search" style="float: right;margin-bottom: 10px;" round>{{$t('lookall')}}</el-button>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="6" :offset="1">

        </el-col>
      </el-row>
    </div>

    <BlogFoot></BlogFoot>

  </div>
</template>

<script>
    import common from '../config/common.js';
    import BlogFoot from './common/BlogFoot.vue';
    import BlogHeader from './common/BlogHeader.vue';
    import MyBlog from './common/MyBlog.vue';

    export default {
  name: 'Home',
    data() {
        return {
            activeName1: 0,
            activeName2: 4,
            time: 2,
            imgs: [],
            list: [],
            top: [],
            look: [],
            clickNum:0,
            threePicLoading: true,
            listLoading: true,
            topLoading: true,
            loading: true
        };
    },components:{
            BlogFoot,
            BlogHeader,
            MyBlog
        },
    methods: {
        getPic(){
            if(this.$cookie.get('pics')){
                this.imgs = JSON.parse(this.$cookie.get('pics'));
                this.threePicLoading = false;
            }else{
                this.$axios.get(common.apiurl+'/api/pic').then((response)=>{
                    if(response.data.code==0){
                        this.imgs = response.data.data;
                        this.threePicLoading = false;
                        this.$cookie.set('pics',JSON.stringify(this.imgs), 1);
                    }
                    else {
                        this.$message({
                            message: this.$t('common.neterror'),
                            type: 'warning'
                        });
                    }
                }).catch((error)=>{
                    this.$message({
                        message: this.$t('common.neterror'),
                        type: 'warning'
                    });
                });
            }

        },clickTimes(){
            this.clickNum += 5;
        },getList(){
            if(this.$cookie.get('list')){
                this.list = JSON.parse(this.$cookie.get('list'));
                this.listLoading = false;
            }else{
                this.$axios.get(common.apiurl+'/api/pc/list').then((response)=>{
                    if(response.data.code==0){
                        this.list = response.data.data;
                        this.listLoading = false;
                        this.$cookie.set('list',JSON.stringify(this.list), 1);
                    }
                    else {
                        this.$message({
                            message: this.$t('common.neterror'),
                            type: 'warning'
                        });
                    }
                }).catch((error)=>{
                    this.$message({
                        message: this.$t('common.neterror'),
                        type: 'warning'
                    });
                });
            }

        },getTop(){
            if(this.$cookie.get('look')){
                this.top = JSON.parse(this.$cookie.get('top'));
                this.look = JSON.parse(this.$cookie.get('look'));
                this.topLoading = false;
            }else{
                this.$axios.get(common.apiurl+'/api/pc/top').then((response)=>{
                    if(response.data.code==0){
                        for(var i =0;i<10;i++){
                            if(i<=5){
                                this.look[i] = response.data.data[i];
                            }else{
                                this.top[i-6] = response.data.data[i];
                            }
                        }
                        this.topLoading = false;
                        this.$cookie.set('top',JSON.stringify(this.top), 1);
                        this.$cookie.set('look',JSON.stringify(this.look), 1);

                    }
                    else {
                        this.$message({
                            message: this.$t('common.neterror'),
                            type: 'warning'
                        });
                    }
                }).catch((error)=>{
                    this.$message({
                        message: this.$t('common.neterror'),
                        type: 'warning'
                    });
                });
            }

        }

        ,urlRedirect(id,type){
            if(type==1)this.$router.push({path:'/diary'});
            else if(type==2)this.$router.push({path:'/it'});
            else this.$router.push({path:'/detail/'+id});
        },handleWidth(){
            if(document.documentElement.clientWidth<=1450)this.time=3;
            else this.time=2;
        }
    },created(){
        this.getPic();
        this.getList();
        this.getTop();
        this.handleWidth();
    },mounted() {
            window.addEventListener('resize', this.handleWidth)
        }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .time {
    font-size: 13px;
    color: #999;
  }

  .url-detail{
    margin-top: 10px;
  }
  .url-detail span{
    margin-right: 18px;
  }
  .url-detail a{
    color: #AF441E;
    text-decoration:none;
  }
  .article img{
    height: 150px;
    width:100%;
    }
  .three-pic{
    height: 402.2px;
  }
  .three-pic img{
    height: 100%;
    width:100%;
  }
  .article .el-card__body{
    height: 150px;
    width:300px;
  }
  .intro .el-card__body{
    padding: 0px;
  }
  .el-col .el-col-7{
    border: 1px solid red;
  }
  .article .el-col-8{
    padding:5px;
  }
  .article h3{
    font-size: 14px;
    color: #333;
  }
  .article h4{
    font-size: 12px;
    color: #999;
    line-height: 20px;
    font-weight: normal;
  }
  .intro{
    text-indent:2em;
    font-size: 12.5px;
    color: #999;
    line-height: 20px;
    font-weight: normal;
  }
  .new{
    height: 402.2px;
  }




</style>



// WEBPACK FOOTER //
// src/components/Home.vue